<template>
  <AppSpinner v-if="isLoading" style="top: 50%; margin-top: -4rem; right: 50%; margin-right: -4rem" class="text-secondary position-fixed" size="8"/>
  <div v-else>
    <b-row id="sign-up" class="justify-content-center align-items-center d-flex min-vh-100 h-100 w-100 m-0">
      <b-col xl="5" lg="6" md="6" sm="10">
        <section class="p-4">
          <b-img v-if="showLogo" :src="$getConst.images.logo_default" height="70" center block/>
          <div class="pt-4 px-xl-4 px-md-3">
            <template v-if="isTokenExpired">
              <template v-if="isNewLinkSent">
                <h4 class="text-center text-success font-weight-bold pt-3">
                  <i :class="[this.$getConst.icons.check, 'mr-1']"></i>
                  {{$t(this.$getConst.pages.sign_up.new_link_sent_message) | capitalize}}
                </h4>
              </template>
              <template v-else>
                <h4 class="text-center font-weight-bold pt-3">{{$t(this.$getConst.pages.sign_up.expired_token_message) | capitalize}}</h4>
                <AppConfirmButtons
                  no-cancel
                  :is-loading="isResendingLink"
                  :submit-text="$getConst.pages.sign_up.resend_link_button"
                  @onSubmit="resendNewLink"
                />
              </template>
            </template>
            <h4 v-else-if="isTokenInvalid" class="text-center font-weight-bold pt-3">{{$t(this.$getConst.pages.sign_up.invalid_token_message) | capitalize}}</h4>
            <div v-else-if="!isTokenUsed" class="text-center font-weight-bold pt-3">
              <h4 class="text-center font-weight-bold mb-4">{{$t(this.$getConst.pages.sign_up.used_token_message) | capitalize}}</h4>
              <b-button
                class="text-uppercase px-4"
                pill
                variant="primary"
                size="lg"
                @click="$router.replace('/')"
              >
                {{$t(this.$getConst.pages.settings.sign_in)}}
              </b-button>
            </div>
            <SignUpForm v-else/>
          </div>
        </section>
      </b-col>
    </b-row>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
  import SignUpForm from "./SignUpForm";
  import {resendSignUpInvitationEmailByUser, verifySignUpToken} from "../../api/user.api";
  import AppSpinner from "../../components/common/utils/AppSpinner";
  import AppConfirmButtons from "../../components/common/utils/AppConfirmButtons";

  export default {
    name: "index",
    components: {AppConfirmButtons, AppSpinner, SignUpForm},
    data() {
      return {
        isLoading: true,
        isTokenExpired: false,
        isTokenInvalid: false,
        isTokenUsed: false,
        isNewLinkSent: false,
        isResendingLink: false,
        showLogo: true
      }
    },
    methods: {
      verifySignUpToken() {
        const token = this.$route.query.token_hint;
        verifySignUpToken(token).then(
          (response) => {
            this.isTokenUsed = response.data.isValid;
            this.isLoading = false;
          },
          (error) => {
            if (error.response.data.error.toLowerCase() === "expired") {
              this.isTokenExpired = true;
            } else if (error.response.data.error.toLowerCase() === "invalid") {
              this.isTokenInvalid = true;
            }
            this.isLoading = false;
          }
        )
        if (this.$store.getters["auth/isAuthenticated"]) {
          this.$router.replace("/");
        }
      },
      resendNewLink() {
        const token = this.$route.query.token_hint;
        this.isResendingLink = true;
        resendSignUpInvitationEmailByUser(token).then(
          () => {
            this.$snotify.success(
              this.$t(this.$getConst.pages.alerts.success_operation),
              this.$t(this.$getConst.pages.alerts.success)
            );
            this.isNewLinkSent = true;
            this.isResendingLink = false;
          },
          (error) => {
            this.isResendingLink = false;
            if (error.response.data.error.toLowerCase() === "token not expired") {
              this.isTokenExpired = false;
              this.$snotify.error(this.$t(this.$getConst.pages.alerts.error));
            } else if (error.response.data.error.toLowerCase() === "invalid") {
              this.isTokenInvalid = true;
              this.$snotify.error(
                this.$t(this.$getConst.pages.sign_up.invalid_token_message),
                this.$t(this.$getConst.pages.alerts.error)
              );
            } else {
              this.handleApiError(error);
            }
          }
        )
      }
    },
    created() {
      if (window.location.origin.includes(process.env.VUE_APP_HAYS_URL_PREFIX)) {
        this.showLogo = false;
      }
      this.verifySignUpToken();
    }
  }
</script>

<style scoped>

</style>
